var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"canvas"}},[_c('div',{attrs:{"id":"stars-1"}}),_c('div',{attrs:{"id":"stars-2"}}),_c('div',{attrs:{"id":"stars-3"}})])}]

export { render, staticRenderFns }